import React, { createContext, useContext, useState, useCallback } from 'react'

const PageTransitionContext = createContext(null)

export function PageTransitionProvider({ children }) {
  const [transition, setTransition] = useState(null)

  const startTransition = useCallback((data) => {
    setTransition((prev) => {
      if (prev) return prev
      return { ...data, targetRect: null, phase: 'exit' }
    })
  }, [])

  const setPhase = useCallback((phase) => {
    setTransition((prev) => (prev ? { ...prev, phase } : null))
  }, [])

  const setTargetRect = useCallback((targetRect) => {
    setTransition((prev) => (prev ? { ...prev, targetRect } : null))
  }, [])

  const endTransition = useCallback(() => {
    setTransition(null)
  }, [])

  return (
    <PageTransitionContext.Provider
      value={{
        transition,
        startTransition,
        setPhase,
        setTargetRect,
        endTransition,
      }}
    >
      {children}
    </PageTransitionContext.Provider>
  )
}

export function usePageTransition() {
  return useContext(PageTransitionContext)
}
